import { render, staticRenderFns } from "./tresultEdit.vue?vue&type=template&id=662390aa"
import script from "./tresultEdit.vue?vue&type=script&lang=js"
export * from "./tresultEdit.vue?vue&type=script&lang=js"
import style0 from "./tresultEdit.vue?vue&type=style&index=0&id=662390aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports